import { useState } from "react";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Spinner from "react-bootstrap/Spinner";
import { submitSupportRequest } from "../api.js";

export default function SupportForm({ user, token }) {
  const [message, setMessage] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      await submitSupportRequest(token, { message });
      setSubmitted(true);
    } catch (err) {
      setError(err.message || "Failed to submit. Please try again.");
    } finally {
      setSubmitting(false);
    }
  }

  if (submitted) {
    return (
      <Alert variant="success" className="mb-0">
        Thank you for reaching out! We will get back to you shortly.
      </Alert>
    );
  }

  return (
    <Form onSubmit={handleSubmit}>
      <h5 className="pmp-contact-form-title">Support Request</h5>
      <p className="text-secondary small mb-4">Describe your issue and we'll get back to you as soon as possible.</p>
      {error && <Alert variant="danger">{error}</Alert>}
      <Row className="g-3 mb-3">
        <Col sm={6}>
          <Form.Group>
            <Form.Label>Name</Form.Label>
            <Form.Control value={user.name} disabled readOnly />
          </Form.Group>
        </Col>
        <Col sm={6}>
          <Form.Group>
            <Form.Label>Email</Form.Label>
            <Form.Control type="email" value={user.email} disabled readOnly />
          </Form.Group>
        </Col>
      </Row>
      <Form.Group className="mb-4">
        <Form.Label>How can we help you? <span className="text-danger">*</span></Form.Label>
        <Form.Control
          as="textarea"
          rows={4}
          required
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Describe your issue or question in detail…"
        />
      </Form.Group>
      <div className="d-flex justify-content-end">
        <Button type="submit" variant="primary" disabled={submitting}>
          {submitting ? <><Spinner size="sm" className="me-2" />Sending…</> : "Submit Request"}
        </Button>
      </div>
    </Form>
  );
}
